import React, { ReactElement } from 'react';
import { CasesParams } from 'utils/useCasesParams/types';
import { StudyAlgorithmExecutionForm } from './StudyAlgorithmExecutionForm';

export interface ExecuteStudyAlgorithmProps {
  onClose: (event?: any, force?: boolean) => void;
  casesParams: CasesParams;
}

export const ExecuteStudyAlgorithm = (props: ExecuteStudyAlgorithmProps): ReactElement => {
  return <StudyAlgorithmExecutionForm {...props} />;
};
